// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   ChevronDown,
//   ChevronUp,
//   Globe, // Using Globe for Reddit as per original code
//   Info,
//   Heart,
//   MessageSquare,
//   ExternalLink,
//   CheckCircle,
//   Sparkles,
//   Copy,
//   Check,
// } from "lucide-react";

// const OpportunityCard = React.memo(({ opportunity, selectedProduct, expandedCard, toggleCard, togglePostCompletion }) => {
//   const [copied, setCopied] = useState(false);

//   // Reset copied state if the card data changes
//   useEffect(() => {
//     setCopied(false);
//   }, [opportunity.id]);

//   // --- Copy Logic (using modern API with fallback) ---
//   const handleCopy = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     const textToCopy =
//       opportunity.details.comment ||
//       `Introduce yourself and explain how ${selectedProduct?.name || "our product"} could help with their specific need.`;

//     if (navigator.clipboard && window.isSecureContext) {
//       navigator.clipboard
//         .writeText(textToCopy)
//         .then(() => {
//           setCopied(true);
//           setTimeout(() => setCopied(false), 2000);
//         })
//         .catch((err) => {
//           console.error("Clipboard API error:", err);
//           fallbackCopy(textToCopy); // Attempt fallback
//         });
//     } else {
//       fallbackCopy(textToCopy); // Use fallback if API unavailable
//     }
//   };

//   const fallbackCopy = (text) => {
//     try {
//       const textArea = document.createElement("textarea");
//       textArea.value = text;
//       textArea.style.position = "fixed";
//       textArea.style.opacity = "0";
//       document.body.appendChild(textArea);
//       textArea.focus();
//       textArea.select();
//       const successful = document.execCommand("copy");
//       document.body.removeChild(textArea);
//       if (successful) {
//         setCopied(true);
//         setTimeout(() => setCopied(false), 2000);
//       } else {
//         console.error("Fallback copy failed");
//         alert("Copy failed. Please copy manually.");
//       }
//     } catch (err) {
//       console.error("Fallback copy exception:", err);
//       alert("Copy failed. Please copy manually.");
//     }
//   };

//   // --- Helper Functions ---
//   const getPlatformIcon = (platform) => {
//     // Simplified based on usage, assuming only Reddit for this card
//     return <Globe size={18} className="text-orange-500" />;
//   };

//   const getScoreBadgeColor = (score) => {
//     const numScore = Number(score) || 0; // Ensure it's a number
//     if (numScore >= 80) return "bg-green-100 text-green-800 border-green-200";
//     if (numScore >= 60) return "bg-yellow-100 text-yellow-800 border-yellow-200";
//     return "bg-red-100 text-red-800 border-red-200";
//   };

//   const isExpanded = expandedCard === opportunity.id;

//   return (
//     // Root element with layout animation enabled
//     <motion.div
//       layout // <<< KEY PROP FOR SMOOTH LAYOUT CHANGES
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -20 }} // Animation when removed by AnimatePresence
//       transition={{ duration: 0.3, ease: "easeInOut" }} // Optional: customize animation timing
//       className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-opacity duration-300 ${
//         opportunity.open_insight ? "opacity-60" : "opacity-100" // Use opacity transition
//       }`}
//     >
//       {/* Card Content Area */}
//       <div className="p-5">
//         {/* Card Header */}
//         <div className="flex justify-between items-start mb-3">
//           {/* Left side: Platform, Title, Date */}
//           <div>
//             <div className="flex items-center space-x-2 mb-1 text-xs">
//               {getPlatformIcon(opportunity.details?.platform)}
//               <span className="font-medium text-gray-600">{opportunity.details?.platform || "Reddit"}</span>
//               <span className="text-gray-400">
//                 {opportunity.details?.timestamp || (opportunity.created_at ? new Date(opportunity.created_at).toLocaleDateString() : "")}
//               </span>
//             </div>
//             <h3 className={`text-lg font-semibold text-gray-900 ${opportunity.open_insight ? "line-through" : ""}`}>
//               {opportunity.details?.post_title || "Untitled Post"}
//             </h3>
//           </div>
//           {/* Right side: Score, Expand Button */}
//           <div className="flex items-center space-x-2 flex-shrink-0">
//             <span
//               className={`text-sm font-bold rounded-full px-2.5 py-1 border ${getScoreBadgeColor(opportunity.details?.lead_quality_score)}`}
//             >
//               {opportunity.details?.lead_quality_score || 0}
//             </span>
//             <button
//               onClick={() => toggleCard(opportunity.id)}
//               className="p-1 hover:bg-gray-100 rounded-full text-gray-500 hover:text-gray-700 transition-colors"
//               aria-label={isExpanded ? "Collapse card" : "Expand card"}
//             >
//               {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
//             </button>
//           </div>
//         </div>

//         {/* Excerpt */}
//         <div className="bg-gray-50 rounded-lg p-3 mb-3 border border-gray-100">
//           <p className="text-sm text-gray-700 line-clamp-3">
//             {" "}
//             {/* Limit lines */}
//             {opportunity.details?.post_excerpt || "No content available"}
//           </p>
//         </div>

//         {/* Score Explanation */}
//         <div className="flex items-center text-xs text-gray-500">
//           <Info size={14} className="mr-1.5 text-green-500 flex-shrink-0" />
//           <span>{opportunity.details?.lead_score_explanation || "Potential match for your product"}</span>
//         </div>
//       </div>

//       {/* Stats Section */}
//       <div className="flex items-center text-gray-500 text-sm pb-4 px-5">
//         <div className="flex items-center mr-4">
//           <Heart className="w-4 h-4 mr-1 text-red-500" />
//           <span>{opportunity.details?.like_count ?? opportunity.details?.upvotes ?? 0}</span>
//         </div>
//         <div className="flex items-center mr-4">
//           <MessageSquare className="w-4 h-4 mr-1 text-blue-500" />
//           <span>{opportunity.details?.comment_count ?? 0}</span>
//         </div>
//         {/* Add other relevant stats if available */}
//       </div>

//       {/* Expanded Details Section (Animated) */}
//       <AnimatePresence initial={false}>
//         {isExpanded && !opportunity.open_insight && (
//           <motion.div
//             key="expanded-content" // Add key for AnimatePresence child
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: "auto" }}
//             exit={{ opacity: 0, height: 0 }}
//             transition={{ duration: 0.3, ease: "easeInOut" }}
//             className="border-t border-gray-200 overflow-hidden" // Added overflow-hidden
//           >
//             <div className="p-5">
//               {/* Suggested Response Box */}
//               <div className="bg-green-50 border border-green-100 rounded-lg p-4 mb-4">
//                 <h4 className="font-medium mb-2 text-green-800 flex items-center">
//                   <Sparkles size={18} className="mr-2 text-green-500" />
//                   Suggested Response
//                 </h4>
//                 <p className="text-gray-700 text-sm break-words">
//                   {" "}
//                   {/* Added break-words */}
//                   {opportunity.details?.comment ||
//                     `Introduce yourself and explain how ${selectedProduct?.name || "our product"} could help with their specific need.`}
//                 </p>
//                 <div className="flex justify-end mt-3">
//                   <button
//                     onClick={handleCopy}
//                     className="text-xs flex items-center space-x-1.5 text-green-600 hover:text-green-800 font-medium transition-colors"
//                     aria-label="Copy suggested response"
//                   >
//                     {copied ? <Check size={14} /> : <Copy size={14} />}
//                     <span>{copied ? "Copied!" : "Copy text"}</span>
//                   </button>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex flex-col sm:flex-row gap-3 mt-4">
//                 <a // Changed to anchor tag for external link best practices
//                   href={opportunity.details?.post_url}
//                   target="_blank"
//                   rel="noopener noreferrer" // Security best practice
//                   className="text-sm bg-white text-green-700 border border-green-200 hover:bg-green-50 px-4 py-2 rounded-lg flex items-center justify-center space-x-1.5 font-medium transition-colors"
//                 >
//                   <ExternalLink size={14} />
//                   <span>View Original</span>
//                 </a>
//                 <button
//                   className="text-sm bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded-lg flex items-center justify-center space-x-1.5 font-medium transition-colors"
//                   onClick={() => togglePostCompletion(opportunity.id)}
//                   aria-label="Mark opportunity as engaged"
//                 >
//                   <CheckCircle size={14} />
//                   <span>Mark as Engaged</span>
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div> // End root motion.div
//   );
// });

// export default OpportunityCard; // Assuming it's in its own file

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp, Globe, Info, Heart, MessageSquare, ExternalLink, CheckCircle, Sparkles, Copy, Check } from "lucide-react";
import PremiumLeadGate from "./PremiumLeadGate"; // Import the new component

const OpportunityCard = ({
  opportunity,
  selectedProduct,
  expandedCard,
  toggleCard,
  togglePostCompletion,
  isPremiumUser = false, // Add this prop to check if user is on premium plan
  onUpgradeClick, // Add callback for upgrade button
  leadIndex = 0, // Add index to know if this is a high-quality lead
}) => {
  const [copied, setCopied] = useState(false);

  // Determine if this lead should be locked (free users only see top N leads)
  const isTopLead = leadIndex < 3; // Show first 3 leads to free users
  const shouldLockLead = !isPremiumUser && !isTopLead;

  // Reset copied state if the card data changes
  useEffect(() => {
    setCopied(false);
  }, [opportunity.id]);

  // Copy logic
  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const textToCopy =
      opportunity.details.comment ||
      `Introduce yourself and explain how ${selectedProduct?.name || "our product"} could help with their specific need.`;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => {
          console.error("Clipboard API error:", err);
          fallbackCopy(textToCopy);
        });
    } else {
      fallbackCopy(textToCopy);
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } else {
        console.error("Fallback copy failed");
        alert("Copy failed. Please copy manually.");
      }
    } catch (err) {
      console.error("Fallback copy exception:", err);
      alert("Copy failed. Please copy manually.");
    }
  };

  // Helper Functions
  const getPlatformIcon = (platform) => {
    return <Globe size={18} className="text-orange-500" />;
  };

  const getScoreBadgeColor = (score) => {
    const numScore = Number(score) || 0;
    if (numScore >= 80) return "bg-green-100 text-green-800 border-green-200";
    if (numScore >= 60) return "bg-yellow-100 text-yellow-800 border-yellow-200";
    return "bg-red-100 text-red-800 border-red-200";
  };

  const isExpanded = expandedCard === opportunity.id;

  // Card click handler that respects premium status
  const handleCardClick = () => {
    if (shouldLockLead) {
      onUpgradeClick();
    } else {
      toggleCard(opportunity.id);
    }
  };

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-opacity duration-300 relative ${
        opportunity.open_insight ? "opacity-60" : "opacity-100"
      }`}
    >
      {/* Premium Gate Overlay for locked leads */}
      {shouldLockLead && <PremiumLeadGate onClick={onUpgradeClick} />}

      {/* Card Content Area */}
      <div className="p-5" onClick={handleCardClick}>
        {/* Card Header */}
        <div className="flex justify-between items-start mb-3">
          {/* Left side: Platform, Title, Date */}
          <div>
            <div className="flex items-center space-x-2 mb-1 text-xs">
              {getPlatformIcon(opportunity.details?.platform)}
              <span className="font-medium text-gray-600">{opportunity.details?.platform || "Reddit"}</span>
              <span className="text-gray-400">
                {opportunity.details?.timestamp || (opportunity.created_at ? new Date(opportunity.created_at).toLocaleDateString() : "")}
              </span>
            </div>
            <h3 className={`text-lg font-semibold text-gray-900 ${opportunity.open_insight ? "line-through" : ""}`}>
              {opportunity.details?.post_title || "Untitled Post"}
            </h3>
          </div>

          {/* Right side: Score, Expand Button */}
          <div className="flex items-center space-x-2 flex-shrink-0">
            <span
              className={`text-sm font-bold rounded-full px-2.5 py-1 border ${getScoreBadgeColor(opportunity.details?.lead_quality_score)}`}
            >
              {opportunity.details?.lead_quality_score || 0}
            </span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (!shouldLockLead) toggleCard(opportunity.id);
              }}
              className="p-1 hover:bg-gray-100 rounded-full text-gray-500 hover:text-gray-700 transition-colors"
              aria-label={isExpanded ? "Collapse card" : "Expand card"}
            >
              {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
          </div>
        </div>

        {/* Excerpt */}
        <div className="bg-gray-50 rounded-lg p-3 mb-3 border border-gray-100">
          <p className="text-sm text-gray-700 line-clamp-3">{opportunity.details?.post_excerpt || "No content available"}</p>
        </div>

        {/* Score Explanation */}
        <div className="flex items-center text-xs text-gray-500">
          <Info size={14} className="mr-1.5 text-green-500 flex-shrink-0" />
          <span>{opportunity.details?.lead_score_explanation || "Potential match for your product"}</span>
        </div>
      </div>

      {/* Stats Section */}
      <div className="flex items-center text-gray-500 text-sm pb-4 px-5">
        <div className="flex items-center mr-4">
          <Heart className="w-4 h-4 mr-1 text-red-500" />
          <span>{opportunity.details?.like_count ?? opportunity.details?.upvotes ?? 0}</span>
        </div>
        <div className="flex items-center mr-4">
          <MessageSquare className="w-4 h-4 mr-1 text-blue-500" />
          <span>{opportunity.details?.comment_count ?? 0}</span>
        </div>
      </div>

      {/* Expanded Details Section (Animated) */}
      <AnimatePresence initial={false}>
        {isExpanded && !opportunity.open_insight && !shouldLockLead && (
          <motion.div
            key="expanded-content"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="border-t border-gray-200 overflow-hidden"
          >
            <div className="p-5">
              {/* Suggested Response Box */}
              <div className="bg-green-50 border border-green-100 rounded-lg p-4 mb-4">
                <h4 className="font-medium mb-2 text-green-800 flex items-center">
                  <Sparkles size={18} className="mr-2 text-green-500" />
                  Suggested Response
                </h4>
                <p className="text-gray-700 text-sm break-words">
                  {opportunity.details?.comment ||
                    `Introduce yourself and explain how ${selectedProduct?.name || "our product"} could help with their specific need.`}
                </p>
                <div className="flex justify-end mt-3">
                  <button
                    onClick={handleCopy}
                    className="text-xs flex items-center space-x-1.5 text-green-600 hover:text-green-800 font-medium transition-colors"
                    aria-label="Copy suggested response"
                  >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                    <span>{copied ? "Copied!" : "Copy text"}</span>
                  </button>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 mt-4">
                <a
                  href={opportunity.details?.post_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm bg-white text-green-700 border border-green-200 hover:bg-green-50 px-4 py-2 rounded-lg flex items-center justify-center space-x-1.5 font-medium transition-colors"
                >
                  <ExternalLink size={14} />
                  <span>View Original</span>
                </a>
                <button
                  className="text-sm bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded-lg flex items-center justify-center space-x-1.5 font-medium transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePostCompletion(opportunity.id);
                  }}
                  aria-label="Mark opportunity as engaged"
                >
                  <CheckCircle size={14} />
                  <span>Mark as Engaged</span>
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default React.memo(OpportunityCard);
